import { render, staticRenderFns } from "./C1Paginator.vue?vue&type=template&id=1af0f5ff&scoped=true&"
import script from "./C1Paginator.vue?vue&type=script&lang=js&"
export * from "./C1Paginator.vue?vue&type=script&lang=js&"
import style0 from "./C1Paginator.vue?vue&type=style&index=0&id=1af0f5ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af0f5ff",
  null
  
)

export default component.exports